import { openExternalLink } from "@tm/insurance/utils";
import {
  AnchorTag,
  FlexComp,
  ImageComponent,
  ParaTag,
  SpanTag,
} from "@tm/static";
import { theme } from "libs/ui-widgets/src/lib/static/css/Global";
import { useCallback } from "react";
import FormattedText, { TextNodeType } from "../FormattedText/FormattedText";
import {
  DnldPolicyComponentStyle,
  PolicyItem,
  TravNumber,
} from "./DnldPolicyComponent.style";

interface BackDropProp {
  data?: {
    Title?: TextNodeType | string;
    Description?: TextNodeType | string;
    Link?: {
      DownloadUrl: string;
    };
  }[];
  travellersInsured?: TextNodeType | string;
}

const DnldPolicyComponent = ({ data, travellersInsured }: BackDropProp) => {
  const handleDownload = useCallback((downloadUrl?: string) => {
    if (downloadUrl) {
      openExternalLink(downloadUrl);
    }
  }, []);

  return (
    <DnldPolicyComponentStyle>
      <FlexComp gap="8px" alignItems="center" margin="0 0 24px">
        <ImageComponent
          width="24px"
          height="24px"
          src="https://tripmoneycmsimgak.mmtcdn.com/img/people_Group_Icon_d97975a5cb.svg"
        />
        <SpanTag fontWeight="black" fontSize="large" color={theme.greyText}>
          <FormattedText value={travellersInsured} />
        </SpanTag>
      </FlexComp>
      {data?.map((item, index: number) => {
        return (
          <PolicyItem firstChild={index == 0} key={index}>
            <TravNumber>{index + 1}</TravNumber>
            <div>
              {item.Title && (
                <ParaTag fontSize="md" fontWeight="black">
                  <FormattedText value={item.Title} />
                </ParaTag>
              )}
              <div>
                {item.Description && (
                  <SpanTag fontSize="xs" color={theme.greyText7}>
                    <FormattedText value={item.Description} />
                  </SpanTag>
                )}
              </div>
            </div>
            <AnchorTag
              margin="0 0 0 auto"
              textTransform="uppercase"
              fontWeight="black"
              handleClick={() => handleDownload(item?.Link?.DownloadUrl)}
            >
              Download
            </AnchorTag>
          </PolicyItem>
        );
      })}
    </DnldPolicyComponentStyle>
  );
};

export default DnldPolicyComponent;
